import { render } from "./ComponentManager.vue?vue&type=template&id=e184545e&scoped=true"
import script from "./ComponentManager.vue?vue&type=script&lang=js"
export * from "./ComponentManager.vue?vue&type=script&lang=js"

import "./ComponentManager.vue?vue&type=style&index=0&id=e184545e&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e184545e"]])

export default __exports__